export default __webpack_public_path__ + "static/card-visa-gold@2x-550e7a1b8746226822fac750fdabed72.png";